import React from "react";
import { Heading } from "@bluecrew/web-react-core";

interface TitleProps {
  title?: string;
}

export const Title = ({ title }: TitleProps) =>
  title ? <Heading data-testid="icon-header-title">{title}</Heading> : null;
